// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2054":"690f7090","2742":"690f7090","3437":"48f6fbc2","5518":"5d563293","6519":"690f7090"}[chunkId] + ".chunk.css";
};